<template>
    <div>
        <!-- 面包屑组件 -->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
            <el-breadcrumb-item>财务中心</el-breadcrumb-item>
            <el-breadcrumb-item>工资列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 内容卡片 -->
        <el-card>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="工资管理" name="first">
                    <!-- 查询框 -->
                    <el-row :gutter="24">
                        <el-col :span="2.5">
                            <el-button @click="handleSetRules" type="primary">设置工资规则</el-button>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo.months" placeholder="请选择结算月份">
                                <el-option
                                v-for="item in monthList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="10">
                            <el-button @click="handleSearch(1)" type="primary">搜索</el-button>
                            <el-button @click="handleAdd(1)" type="success">新增</el-button>
                            <el-button @click="handleClear(1)" type="warning">清空</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="dataList"  @selection-change="handleSelectionChange" stripe>
                        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                        <el-table-column label="结算标题" prop="settleAccountsTitle"></el-table-column>
                        <el-table-column label="结算金额"  prop="totalAmount"></el-table-column>
                        <el-table-column label="结算月份"  prop="months"></el-table-column>
                        <el-table-column label="结算对象"  prop="settleAccountsObject">
                            <template slot-scope="scope">
                                <span>{{scope.row.postion==1?'所有教师':'所有学管师'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作人"  prop="createBy_dictText"></el-table-column>
                        <el-table-column label="操作时间"  prop="createTime"></el-table-column>
                        <el-table-column label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button @click="handleEdit(scope.row)" type="text">编辑</el-button>
                                <el-button @click="handleDelete(scope.row)" type="text">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 页数码 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryInfo.pageNo"
                        :page-sizes="[10, 15, 20, 25, 30, 35]"
                        :page-size="queryInfo.pageSize"
                        :total="total"
                        background
                    ></el-pagination>
                </el-tab-pane>
                <el-tab-pane label="工资报表" name="second">
                    <!-- 查询框 -->
                    <el-row :gutter="24">
                        <el-col :span="4">
                            <el-select v-model="queryInfo2.month" placeholder="请选择结算月份">
                                <el-option
                                v-for="item in monthList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="queryInfo2.teacherId" placeholder="请选择老师">
                                <el-option
                                    v-for="item in teacherList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="10">
                            <el-button @click="handleSearch(2)" type="primary">搜索</el-button>
                            <el-button @click="handleClear(2)" type="warning">清空</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="dataList2"  @selection-change="handleSelectionChange" stripe>
                        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                        <el-table-column label="结算月份" prop="month"></el-table-column>
                        <el-table-column label="上课老师" prop="teacherName"></el-table-column>
                        <el-table-column label="手机号码" prop="teacherPhone"></el-table-column>
                        <el-table-column label="上课薪酬" prop="teachingSalary"></el-table-column>
                        <el-table-column label="扣除金额" prop="deductSalary"></el-table-column>
                        <!-- <el-table-column label="岗位级别"  prop="postion">
                            <template slot-scope="scope">
                                <span>{{postionTyepe(scope.row.postion)}}</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="岗位级别系数" prop="postionRation"></el-table-column>
                        <el-table-column label="小计"  prop="total"></el-table-column>
                        <el-table-column label="餐补" prop=""></el-table-column>
                        <el-table-column label="全勤奖" prop=""></el-table-column>
                        <el-table-column label="其他奖励" prop=""></el-table-column>
                        <el-table-column label="其他扣除" prop=""></el-table-column>
                        <el-table-column label="总计"  prop=""></el-table-column>
                    </el-table>

                    <!-- 页数码 -->
                    <el-pagination
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page.sync="queryInfo2.pageNo"
                        :page-sizes="[10, 15, 20, 25, 30, 35]"
                        :page-size="queryInfo2.pageSize"
                        :total="total2"
                        background
                    ></el-pagination>
                </el-tab-pane>
            </el-tabs>
        </el-card>
        <el-card>

        </el-card>
        <el-dialog
            :title="editData.id?'编辑':'新增结算'"
            :visible.sync="addEditModalShow"
            :close-on-click-modal="false"
            width="30%"
        >
            <el-form :label-position="'right'" label-width="90px">
                <el-form-item label="结算标题" prop="settleAccountsTitle">
                    <el-input v-model="fromData.settleAccountsTitle"></el-input>
                </el-form-item>
                <el-form-item label="结算对象" prop="settleAccountsObject">
                    <el-select v-model="fromData.settleAccountsObject" placeholder="请选择老师">
                        <el-option
                            v-for="item in settleAccountsObjectList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="结算月份" prop="months">
                    <el-select v-model="fromData.months" placeholder="请选择结算月份">
                        <el-option
                        v-for="item in monthList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addEditModalShow = false">取 消</el-button>
                <el-button type="primary" @click="handleOk()">开始结算</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return{
                activeName:'first',
                dataList: [],
                dataList2:[],
                // 排序方式(1价格升序、2价格降序、3次数升序、4次数降序，5新增时间升序，6新增时间降序（默认）
                queryInfo: {
                    months:'',
                    pageSize: 10,
                    pageNo: 1,
                },
                queryInfo2:{
                    id:'',
                    teacherId:'',
                    month:'',
                    pageSize: 10,
                    pageNo: 1,
                },
                settleAccountsObjectList:[
                    { value: 1,label: '所有教师'},
                    { value: 2,label: '所有学管师'},
                ],
                monthList:[
                    { label:'2020年11月份',value: '2020-11'},
                    { label:'2020年10月份',value: '2020-10'},
                    { label:'2020年09月份',value: '2020-09'},
                    { label:'2020年08月份',value: '2020-08'},
                    { label:'2020年07月份',value: '2020-07'},
                    { label:'2020年06月份',value: '2020-06'},
                    { label:'2020年05月份',value: '2020-05'},
                    { label:'2020年04月份',value: '2020-04'},
                    { label:'2020年03月份',value: '2020-03'},
                    { label:'2020年02月份',value: '2020-02'},
                    { label:'2020年01月份',value: '2020-01'}
                ],
                total: 0,
                total2: 0,
                selectList: [],
                fromData:{
                    settleAccountsTitle:'',//结算标题
                    settleAccountsObject: 1,//结算对象
                    months:'',//月份
                    id:''
                },
                addEditModalShow: false,
                editData:{},
                teacherList:[]
            }
        },
        mounted() {
            this.initData();
        },
        methods:{
            async initData() {
                await this.$http.post("/ea/teacher/salary/list",this.queryInfo).then((res) => {
                    let data = res.data;
                    if(data && (data.code == 0 || data.code == 200)){
                        this.dataList = data.result.records;
                        this.total = data.result.total;
                    }else {
                        this.$message({
                            message: data.message,
                            type:'error'
                        });
                    }
                })
            },
            async initData2() {
                await this.$http.post("/ea/teacher/salaryReport/list",this.queryInfo2).then((res) => {
                    let data = res.data;
                    if(data && (data.code == 0 || data.code == 200)){
                        this.dataList2 = data.result.records;
                        this.total2 = data.result.total;
                    }else {
                        this.$message({
                            message: data.message,
                            type:'error'
                        });
                    }
                })
            },
            // 获取所有授课老师
            async getTeacherList() {
                this.courseList = [];
                const { data: res } = await this.$http.get(`/ea/sys/user/getTeacherList`);
                if (res.code !== 200){
                    this.$message.error(res.message);
                }else{
                    let list  = res.result.users;
                    list.map(e=>{
                        let teacherItem = {
                            value:e.id,
                            label:e.realname
                        }
                        this.teacherList.push(teacherItem);
                    })
                }
            },
            postionTyepe(val) {
                let value = '';
                switch (String(val)) {
                    case '0':
                        value = '校长';
                        break;
                    case '1':
                        value = '学管师';
                        break;
                    case '2':
                        value = '老师';
                        break;
                    default:
                        value = ''
                        break;
                }
                return value;
            },
            handleSearch(num) {
                if(num == 1){
                    this.initData();
                }else if(num == 2){
                    this.initData2()
                }
            },
            handleSetRules() {
                this.$router.push('/setRules');
            },
            // 选择tab切换
            handleClick(tab) {
                this.tabName = tab.name
                if(tab.name == 'second'){
                    this.getTeacherList();
                    this.initData2();
                }else {
                    this.initData();
                }
            },
            handleClear(num) {
                if(num == 1){
                    this.queryInfo = {
                        months: '',
                        pageSize: 10,
                        pageNo: 1,
                    }
                }else if(num == 2){
                    this.queryInfo2 = {
                        id:'',
                        teacherId:'',
                        month:''
                    }
                }
            },
            handleAdd() {
                this.fromData={
                    settleAccountsTitle:'',//结算标题
                    settleAccountsObject: 1,//结算对象
                    months:'',//月份
                    id:''
                },
                this.addEditModalShow = true;
            },
            handleSelectionChange(val) {
                this.selectList = val;
            },
            // 套装页码切换
            handleCurrentChange(pageNum){
                this.queryInfo.pageNo = pageNum;
                this.initData();
            },
            handleSizeChange(val) {
                this.queryInfo.pageSize = val;
            },
            handleCurrentChange2(pageNum){
                this.queryInfo2.pageNo = pageNum;
                this.initData2();
            },
            handleSizeChange2(val) {
                this.queryInfo2.pageSize = val;
            },
            handleEdit(record) {
                this.editData = record;
                this.fromData = {
                    settleAccountsTitle: record.settleAccountsTitle,//结算标题
                    settleAccountsObject: record.settleAccountsObject,//结算对象
                    months: record.months,//月份
                    id:record.id
                };
                this.addEditModalShow = true;
            },
            handleDelete(record) {
                this.$confirm('确定删除这条结算数据吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.post("/ea/teacher/salary/delete",{id:record.id}).then((res) => {
                        let data = res.data;
                        if(data && data.code == 0 || data.code == 200){
                            this.$message({
                                message: '删除成功',
                                type:'success'
                            });
                            this.initData();
                        }else {
                            this.$message({
                                showClose: true,
                                message: data.message,
                                type:'error'
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleOk() {
                if(this.editData.id){
                    this.$http.post("/ea/teacher/salary/edit",this.fromData).then((res) => {
                        let data = res.data;
                        if(data && data.code == 0 || data.code == 200){
                            this.$message({
                                message: '编辑成功',
                                type:'success'
                            });
                            this.addEditModalShow = false;
                            this.initData();
                        }else {
                            this.$message({
                                showClose: true,
                                message: data.message,
                                type:'error'
                            });
                        }
                    })
                }else {
                    this.$http.post("/ea/teacher/salary/add",this.fromData).then((res) => {
                        let data = res.data;
                        if(data && data.code == 0 || data.code == 200){
                            this.$message({
                                message: '添加成功',
                                type:'success'
                            });
                            this.addEditModalShow = false;
                            this.initData();
                        }else {
                            this.$message({
                                showClose: true,
                                message: data.message,
                                type:'error'
                            });
                        }
                    })
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .tips {
        color: #666666;
        font-size: 12px;
        margin-left: 22px;
        .icons {
            font-size: 14px;
            color: #666666;
        }
    }
</style>
